import { useQuery } from "react-query"
import { restService } from "../../services/RestService"
import { getAppBasePath } from "../appPath"

/** Tomcat: {prefix}{configured}. Nginx root: configured (/api). Local: absolute URL in config.json. */
function resolveApiBaseUrl(staticConfig = {}) {
    const configured = staticConfig.apiBaseUrl || '/api';
    if (configured.startsWith('http://') || configured.startsWith('https://')) {
        return configured;
    }
    const prefix = getAppBasePath();
    if (prefix) {
        return `${prefix}${configured}`;
    }
    return configured;
}

export const useConfiguration = () => {
    const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
        queryKey: ['config'],
        queryFn: async () => {
            const staticConfig = await restService.get(`${getAppBasePath()}/config.json`);
            return {
                ...staticConfig,
                apiBaseUrl: resolveApiBaseUrl(staticConfig),
            };
        },
        staleTime: Infinity,
        cacheTime: Infinity
    });

    return {
        appConfig: data,
        isLoadingConfiguration: isLoading || isFetching,
        isConfigurationError: isError,
        configurationError: error,
        refetchConfiguration: refetch,
    }
}